import { connect } from 'react-redux';
//
import { IStoreState } from 'store';
import CostFormulaToggle from 'components/cost-formula-toggle/cost-formula-toggle';
import { ECostFormulaParamType } from 'store/deal-evaluation/types';
import { setCostFormulaType } from 'store/deal-evaluation/actions';

export interface ICostFormulaToggleProps {
  selectedCostFormulaType: ECostFormulaParamType;
  setCostFormulaType: (costFormulaType: ECostFormulaParamType) => void;
}

export interface ICostFormulaToggleOwnProps {
  showTitle: boolean;
}

export type TCostFormulaToggleProps = ICostFormulaToggleProps & ICostFormulaToggleOwnProps;

const mapStateToProps = ({ dealEvaluation }: IStoreState) => ({
  selectedCostFormulaType: dealEvaluation.selectedCostFormulaType,
});

const mapDispatchToProps = {
  setCostFormulaType,
};

export default connect(mapStateToProps, mapDispatchToProps)(CostFormulaToggle);
